import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  addItem: 'Add Item',
  description:
    'Organise and manage all your items in one convenient location, add an Item to get started.',
  title: "You don't have any Items",
})
